import { F as FirebaseService, l as isDocumentReferencePath, h as handleResponse, e as isString, t as toMillis, m as dayjs_min, c as collections } from './index-454e4dcf.js';
import { A as AuthService } from './auth.service-530bc2de.js';

var ProfileInfoType;
(function (ProfileInfoType) {
  ProfileInfoType["CURRENT_USER"] = "currentUser";
  ProfileInfoType["ANOTHER_USER"] = "anotherUser";
})(ProfileInfoType || (ProfileInfoType = {}));
class UserService {
  get db() {
    return FirebaseService.firestore();
  }
  async getUserInfo(userDocPath) {
    try {
      if (!isDocumentReferencePath(userDocPath)) {
        throw new Error('Invalid userDocPath:' + userDocPath);
      }
      const userDocRef = this.db.doc(userDocPath);
      const userSnap = await userDocRef.get();
      if (!userSnap.exists) {
        throw new Error('User no exist. ' + userDocPath);
      }
      const data = userSnap.data();
      const glukyUserId = userDocRef.id;
      return handleResponse(Object.assign(Object.assign({}, data), { photoURL: data.urlAvatar, displayName: `${data.name} ${isString(data.lastnames) ? data.lastnames : ''}`.trim(), uid: glukyUserId, docRef: userDocRef, recentNotifications: (data.recentNotifications || []).map(toMillis) }));
    }
    catch (error) {
      return handleResponse(undefined, 'Fail to load user info', error);
    }
  }
  async getUsersBirthday() {
    try {
      //source: https://stackoverflow.com/a/61516548/8644236
      const shortBirthday =  dayjs_min().format('DD/MM');
      if (!FirebaseService.auth().currentUser) {
        throw new Error('User not authenticated yet');
      }
      let queryRef = FirebaseService.firestore()
        .collection(collections.USERS)
        .orderBy('dateBorn')
        .startAt(shortBirthday)
        .endAt(shortBirthday + '~');
      if (AuthService.programId) {
        queryRef = queryRef.where('programId', '==', AuthService.programId);
      }
      const users = await queryRef.get().then(snapshot => snapshot.docs.map(doc => doc.data()));
      return handleResponse(users);
    }
    catch (error) {
      return handleResponse([], 'Fail to load birthdays users', error);
    }
  }
}
const UserService$1 = new UserService();

export { ProfileInfoType as P, UserService$1 as U };
